import { render } from "./icon.vue?vue&type=template&id=ad7dc2a0&scoped=true"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"

import "./icon.vue?vue&type=style&index=0&id=ad7dc2a0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad7dc2a0"]])

export default __exports__